import React from "react";
import "../../App.css";
const Footer = () => {
  return (
    <div className="footer">
      <h3>S&E</h3>
      <hr className="footer-hr" />
      <h5>7.23.2023</h5>
      <p>Created by Ed O'Connor</p>
    </div>
  );
};

export default Footer;
